function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#2F2E2E",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.895.354l.707.707L1.561 25.102l-.707-.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.854 1.06L1.56.355l24.041 24.041-.707.707z"
}));

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg width='26px' height='26px' viewBox='0 0 26 26'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-1829.000000, -60.000000)' fill='%232F2E2E'%3E %3Cg transform='translate(1829.000000, 60.000000)'%3E %3Crect transform='translate(13.227922, 12.727922) rotate(45.000000) translate(-13.227922, -12.727922) ' x='12.7279221' y='-4.27207794' width='1' height='34'%3E%3C/rect%3E %3Crect transform='translate(13.227922, 12.727922) rotate(-45.000000) translate(-13.227922, -12.727922) ' x='12.7279221' y='-4.27207794' width='1' height='34'%3E%3C/rect%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgClose as ReactComponent };